const TabItem = ({ children }: TabItemProps): TabItemType => <>{children}</>

export interface TabItemType extends JSX.Element {}

type TabItemProps = {
    children: JSX.Element | JSX.Element[],
    tabTitle: string
}

export default TabItem